export default __webpack_public_path__ + "static/media/bg-pattern.ed42e1f4.svg";